const creditAccountsUrl = "v2/credit/accounts";
export {
  creditAccountsUrl
};
//# sourceMappingURL=endpoints.js.map
